import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import './Download.css';
import { getDownloadCategories, getDownloads, getItems, downloadFileById } from '../api';

export default function Download() {
  const [categories, setCategories] = useState([]);
  const [downloadsByCode, setDownloadsByCode] = useState({});
  const [selectedCode, setSelectedCode] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    Promise.all([getDownloadCategories(), getDownloads()])
      .then(([categoryResponse, downloadResponse]) => {
        const categoryItems = getItems(categoryResponse);
        const grouped = {};
        categoryItems.forEach((category) => {
          grouped[category.category_code] = [];
        });
        getItems(downloadResponse).forEach((item) => {
          if (!grouped[item.category_code]) grouped[item.category_code] = [];
          grouped[item.category_code].push(item);
        });
        setCategories(categoryItems);
        setDownloadsByCode(grouped);
        setSelectedCode(categoryItems[0]?.category_code || '');
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch download data:', error);
        setIsLoading(false);
        setShowModal(true);
      });
  }, []);

  useEffect(() => {
    if (!showModal) return undefined;
    const timer = setTimeout(() => setShowModal(false), 5000);
    return () => clearTimeout(timer);
  }, [showModal]);

  const handleDownload = (downloadId) => {
    downloadFileById(downloadId)
      .then((response) => {
        const contentDisposition = response.headers['content-disposition'];
        let filename = 'downloaded_file';
        const matches = contentDisposition && contentDisposition.match(/filename="(.+?)"/);
        if (matches?.length > 1) {
          filename = decodeURIComponent(matches[1]);
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => {
        console.error('다운로드 요청 실패:', error);
        setShowModal(true);
      });
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <>
      {showModal && <div className="modal-container">업데이트 예정입니다</div>}
      <div className="download-title">카탈로그 & 제품 사양서 & 인증서</div>
      <div className="download-container">
        <ul className="tab-list">
          {categories.map((category) => (
            <motion.li
              key={category.category_code}
              onClick={() => setSelectedCode(category.category_code)}
              className="tab-item"
              animate={{
                backgroundColor: category.category_code === selectedCode ? '#f0f0f0' : '#fff',
              }}
            >
              {category.category_name}
              {category.category_code === selectedCode && (
                <motion.div
                  className="tab-underline"
                  layoutId="tab-underline"
                  transition={{ type: 'spring', stiffness: 400, damping: 30 }}
                />
              )}
            </motion.li>
          ))}
        </ul>
        <div className="tab-content" style={{ width: '100%' }}>
          <AnimatePresence mode="wait">
            {selectedCode && (
              <motion.div
                key={selectedCode}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.2 }}
              >
                <div className="cards-container">
                  {(downloadsByCode[selectedCode] || []).map((download) => (
                    <div key={download.download_id} className="download-card">
                      {download.preview_image_path && (
                        <img
                          src={`/${download.preview_image_path}`}
                          alt={download.download_name}
                          className="document-image"
                        />
                      )}
                      <div className="document-title">{download.download_name}</div>
                      <button
                        className="download-button"
                        onClick={() => handleDownload(download.download_id)}
                      >
                        다운로드 받기
                      </button>
                    </div>
                  ))}
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </>
  );
}
